import { render, staticRenderFns } from "./FixedDark.vue?vue&type=template&id=dd22ac9c&"
import script from "./FixedDark.vue?vue&type=script&lang=js&"
export * from "./FixedDark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports